export default {
  tracks: [
    {
      id: 1,
      name: 'I want to ..1 ',
      dreams: [],
      goals: [],
      routines: [],
      tasks: []
    },
    {
      id: 2,
      name: 'I want to .. 2',
      dreams: [],
      goals: [],
      routines: [],
      tasks: []
    }
  ]
}
